import React from "react";
import { useHistory } from "react-router-dom";
import { config } from "util/config";
import * as globalFunction from 'util/GlobalFunction';

const Error = () => {
  const areaName = "System";
  const pageName = "Error";

  const history = useHistory();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  // console.log(window.location)
  console.log(history.location)
  //以React.FC为页面入口获取当前用户信息，创建React.Component页面
  return (
    <ErrorPage urlParams={urlParams} areaName={areaName} pageName={pageName} history={history} />
  )
}
export default Error;

class ErrorPage extends React.Component {
  constructor(props) {
    super();
    this.state = {

    }
  }

  render() {
    let type = this.props.urlParams.get('type');
    let message = this.props.urlParams.get('message');
    return (
      <div className="error-page">
        <div><b>{type} Message</b></div>
        <span dangerouslySetInnerHTML={{ __html: message }}></span>
      </div>
    )
  }
}
